import { useState } from "owa-react";
import { useCallback } from "react";

export function useBooleanState(initialValue: boolean): [
    boolean,
    () => void,
    () => void
] {
    const [value, setValue] = useState(initialValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    return [value, setTrue, setFalse];
}
